import { Tabs, TabsList, TabsTrigger } from '@eye-able/ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

type CustomPolicyTab = 'policies' | 'issues' | 'statistics';

const tabs: { id: CustomPolicyTab; route: string; translationKey: string }[] = [
  {
    id: 'policies',
    route: '/governance/custom-policies',
    translationKey: 'policies',
  },
  {
    id: 'issues',
    route: '/governance/custom-policies/issues',
    translationKey: 'issues',
  },
  {
    id: 'statistics',
    route: '/governance/custom-policies/statistics',
    translationKey: 'statistics',
  },
];

export function CustomPolicyTabs({ active }: { active: CustomPolicyTab }) {
  const { t } = useInlineTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = tabs.find((tab) => tab.id === active);

  useDocumentTitle(
    t('customPolicies'),
    activeTab ? t(activeTab.translationKey) : undefined,
  );

  return (
    <Tabs
      value={active}
      onValueChange={(value) => {
        const tab = tabs.find((item) => item.id === value);
        if (tab) {
          const search = searchParams.toString();
          void navigate(`${tab.route}${search ? `?${search}` : ''}`);
        }
      }}
    >
      <TabsList className='eye:w-fit eye:max-w-full'>
        {tabs.map((tab) => (
          <TabsTrigger key={tab.id} value={tab.id}>
            {t(tab.translationKey)}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
